import * as React from 'react';
import HeaderContent from './HeaderContent';
import '../styles/App.css';

const headGlassLeft = require('../images/HeadGlass_Left.png');
const headGlassRight = require('../images/HeadGlass_Right.png');

class HeaderRegion extends React.Component {
  render() {
    return (
        <div className="HeaderOuterRegion">
            <div className="HeaderInnerRegion">
                <table className="HeaderGlassTableRegion" cellPadding="0" cellSpacing="0">
                    <tbody>
                        <tr>
                            <td style={{ width: '72px', height: '61px' }}>
                                <img src={headGlassLeft} className="HeaderGlassLeftImg" alt="" />
                            </td>
                            <td className="HeaderGlassCenterTableCell">
                                <HeaderContent />
                            </td>
                            <td style={{ width: '52px', height: '61px' }}>
                                <img src={headGlassRight} className="HeaderGlassRightImg" alt="" />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
  }
}

export default HeaderRegion;


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/HeaderRegion.tsx